// For consistency, we are using styled-system - docs: https://github.com/jxnblk/styled-system#docs
import images from './Images';

const theme = {
  fontSizes: [16, 20, 24, 28, 32, 64],
  space: [0, 5, 10, 15, 20, 40, 80],
  zIndex: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150],
  fontFamily: 'Roboto Condensed, sans-serif',
  borderRadius: '4px',
  border: '1px solid rgba(50, 50, 93, 0.2)',
  transition: 'all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
  boxShadowTop: '0px -4px 4px -4px rgba(50,50,93,0.3)',
  inputBoxShadow: 'inset 0 0 0 1px rgba(67, 90, 111, 0.15), inset 0 1px 2px rgba(67, 90, 111, 0.15)',
  colors: {
    red: '#D0021B',
    blue: '#4A90E2',
    coal: '#222429',
    error: '#cc0000',
    putty: '#b8b19b',
    white: '#FFFFFF',
    success: '#4ca518',
    pending: '#F2B26F',
    lightGrey: '#545665',
    brownGrey: '#969696',
    paleGrey: '#f0f1f3',
    charcoalGrey: '#404041',
    colourGrey: '"#707172',
    primaryColour: '#090031',
    grayExtraLight: '#EEF1F5',
    shadow: 'rgba(50, 50, 93, 0.3)',
    transparent: 'rgba(0,0,0,0)',
    transparentBlack: 'rgba(0,0,0,0.3)',
    transparentWhite: 'rgba(255,255,255, 0.6)',
    transparentPutty: 'rgba(184, 177, 155, 0.5)',
  },
  gridGutter: '10',
};

export { theme, images };



// WEBPACK FOOTER //
// ./src/theme/index.ts